import React from "react";
import { Redirect, RouteComponentProps } from "react-router";

type OwnProps = {};
type Props = OwnProps & RouteComponentProps;

const TERMS_OF_USE_URL =
  "https://firebasestorage.googleapis.com/v0/b/sweet-space.appspot.com/o/legal%2FSweet%20Terms%20of%20Use.pdf?alt=media&token=353f3801-d7e2-4f0b-8149-f83ce4047fae";

const Terms: React.FC<Props> = props => {
  window.location.href = TERMS_OF_USE_URL;

  return null;
};

export default Terms;
